<template>
  <div class="container">
    <div class="nav">
      <ul class="nav-list">
        <!-- <li class="nav-btn pointer">添加图片</li> -->
        <li class="nav-btn pointer" @click="showTTSModal()"><i class="icon"></i>添加文本</li>
        <li class="nav-item" :class="{active: !currentCate}" @click="setCurrentShapes()">
          全部
        </li>
        <li
          class="nav-item"
          v-for="(item, i) in cates" :key="i"
          :data-cate-id="item.id"
          :class="{active: item.id === currentCate}"
          @click="setCurrentShapes(item.id)"
        >
          {{item.name}}
        </li>
      </ul>
    </div>

    <div class="content">
      <ul class="list">
        <li
          class="item"
          v-for="(item, i) in currentShapes"
          :key="i"
        >
          <div
            class="shape"
            :class="{active: activeShapeId === item.id}"
            @click="selectShape(item.id)"
            @mouseover="hoverShapeId = item.id"
            :data-index="i"
          >
            <!-- <div class="shape__img" :style="{backgroundImage: `url(${$handleAssetsUrl(item.thumbnailUrl)})`}">

            </div> -->
            <img class="shape__img" :src="$handleAssetsUrl(item.url)" alt="" @mousedown.prevent>
            <div
              v-if="item.ownerId"
              v-show="hoverShapeId === item.id"
              class="shape__remove"
              @click.stop="removeUserShape(item)"
            ></div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  // props: ['firstFont'],
  data () {
    return {
      cates: [],
      currentCate: '',
      allShapes: [],
      currentShapes: [
        0, 0,
      ],
      activeShapeId: '',
      hoverShapeId: '',
      firstFont: ''
    }
  },
  created () {
    this.getMaterial();

    this.$bus.once('fontFamily.getFontsFirst', (data) => {
      // let filename = data[0].url.replace(/.+\//, '');
      // data = data[0];
      // let font = {}
      // font.filename = filename;
      // font.url = data.url;
      // font.value = data.url;
      // font.thumb = data.fontUrl;
      // font.title = data.title;

      this.resetFont();
    });

    this.$bus.on('textToShapeDone', (shape) => {
      this.allShapes.unshift(shape);
      this.setCurrentShapes();
      this.activeShapeId = this.currentShapes[0].id;
      // this.getMaterial();
    });
  },
  methods: {
    getMaterial () {
      this.$http.get(`/api/wordcloud?fPage=99999&pIndex=1`)
        .then(res => {
          let data = res.data.data;
          this.allShapes = data.wordclouds.rows;
          this.cates = data.categories;

          this.setCurrentShapes();
          this.activeShapeId = this.currentShapes[0].id;
        })
    },
    setCurrentShapes (cateId) {
      if (!cateId) {
        this.currentShapes = this.allShapes;
        this.currentCate = '';
        return;
      }

      this.currentShapes = this.allShapes.filter(item => item.categoryId === cateId);
      this.currentCate = cateId;
    },
    selectShape (id) {
      this.activeShapeId = id;
    },
    getActiveShape () {
      let ret
      this.allShapes.some(item => {
        if (item.id === this.activeShapeId) {
          ret = item;
          return true;
        }
      });

      return ret;
    },

    showTTSModal () {
      this.$modal.show('wordCloud.textToShape', {firstFont: this.firstFont});
      this.$analysis('word_cloud,click_shape，文字云_点击_形状');
    },

    removeUserShape (item) {
      this.$http.put('/api/wordcloud/update', {
        uid: item.id,
        state: 1,
      })
        .then(res => {
          res.data.data
          let index = this.allShapes.indexOf(item);
          this.allShapes.splice(index, 1);
          this.selectShape(this.allShapes[index].id);
        })
    },

    reset () {
      this.setCurrentShapes();
      this.selectShape(this.allShapes[0].id);
      this.resetFont();
    },

    resetFont () {
      let font = {};
      font.value = font.url = '2018-5-16/1526467728442.TTF';
      font.filename = '1526467728442.TTF';
      font.title = font.label = '方正黑体';
      this.firstFont = font;
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  height: 520px;
  padding-bottom: 10px;
}

.nav-list {
  padding-left: 10px;
  padding-right: 10px;
  // margin-right: 10px;
}

.nav-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 34px;
  line-height: 34px;
  background-color: #ebefff;
  border-radius: 4px;
  border: solid 1px #5778fb;
  color: #5778fb;
  margin-top: 10px;
  &:hover {
    background-color: #d8e0ff;
  }

  & > .icon {
    width: 14px;
    height: 14px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-image: url(../../../../static/svg/word-cloud/file-lite.svg);
    margin-right: 5px;
    // margin-top: 2px;
    // D:\work\laihua-tool\src\components\emodal\wordCloud\shapeControl.vue
    // D:\work\laihua-tool\static\svg\word-cloud\eye.svg
  }
}

.nav-item {
  width: 100px;
  height: 34px;
  line-height: 34px;
  background-color: #f4f4f8;
  border-radius: 4px;
  border: solid 1px #d9ddea;
  margin-top: 10px;
  &:hover {
    background-color: #dfdfe7 !important;
  }

  &.active {
    width: 100px;
    height: 34px;
    background-color: #5778fb;
    border-radius: 4px;
    color: #fff;
    border: none;
    &:hover {
      background-color: #5656e8 !important;
      border-color: #5656e8 !important;
    }
  }
}

.content {
  width: 520px;
  overflow: auto;
}
.list {
  padding-top: 5px;
  line-height: 0;
  text-align: left;
}
.item {
  display: inline-block;
  box-sizing: content-box;
  width: 110px;
	height: 110px;
  padding: 5px;
  line-height: 1;
}
.shape {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 110px;
	height: 110px;
	background-color: #fcfcfe;
	border-radius: 4px;
	border: solid 1px #d9ddea;

  &__img {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 0;
    margin: auto;
    width: auto;
    height: auto;
    max-width: 90%;
    max-height: 90%;
  }

  &__remove {
    position: absolute;
    top: 0;
    right: 0;
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    background-size: 12px 12px;
    background-color: #5778fb;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAtElEQVQokXXQvUoDMBTF8YObHfwAddFF0dXJycEHcPcxfQnXLkI3lSJdFJfSpUuHn4OJpCW5cCG5+Z9czgke8IwTZNAXhbkL5v7qHQcd+BSLwkyDe6zK4A2HDXyGz/L2VTcENzuiOq8//+AcaVe3olfMyvm7wruC4Lh4qTXDpGX2sl3LJJvmvkmy3iIGaSyKyerpP71RGvs46qUXXPfSGKR3GXz00hiIpsETXnDVgWvfFubxF6+7xRzmJTBlAAAAAElFTkSuQmCC');
    background-position: center center;
    cursor: pointer;
  }

  &.active {
    border: solid 2px #5778fb;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/wordCloud/shapeControl.vue